module.exports = __webpack_public_path__ + "img/no_data_w800_h400_1x.41650628.png";